import React, {useState} from "react";
import { Grid, IconButton, InputAdornment, Typography } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import { FlagsDropdown, Textfield } from "../../../components";
import { getCountryIcon } from "../../../helpers";

export default function ({updateSelectedCurrency, contactDetails}) {
    const [editCurrency, setEditCurrency] = useState(false);
    
    return <React.Fragment>{!editCurrency && contactDetails ? <Grid container alignItems={'center'} spacing={4}>
        <Grid item xs={6}>
            <Textfield
                label="Display Currency"
                value={contactDetails.displayCountry.name}
                disabled
                fullWidth
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton onClick={() => setEditCurrency(true)}>
                                <EditIcon />
                            </IconButton>
                        </InputAdornment>
                    ),
                    startAdornment: (
                        <InputAdornment position="start">
                            <img
                                loading="lazy"
                                width="20"
                                src={getCountryIcon(contactDetails.displayCountry.code)}
                            />
                        </InputAdornment>
                    )
                }}
            />
        </Grid>
    </Grid> :
        <Grid container>
            <Grid item xs={12}>
                <Typography gutterBottom sx={{ fontWeight: 600 }}>Display Currency</Typography>
            </Grid>

            <Grid className="DisplayCurrencyDropdown" item xs={6}>
                {
                    contactDetails.displayCountry.name &&
                    <FlagsDropdown selectedOption={contactDetails.displayCountry.name} onChange={updateSelectedCurrency} />
                }
            </Grid>
        </Grid>
    }
    </React.Fragment>
}